import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="container-lookers py-16 max-w-2xl" data-testid="privacy-policy-page">
      <h1 className="font-serif text-5xl mb-8 text-zinc-900">
        Privacy Policy
      </h1>
      <div className="space-y-6 text-sm text-zinc-500 leading-relaxed">
        <p>Lookers respects your privacy. We only collect the information needed to process your orders, manage your account and improve your experience — including your name, contact details, shipping address and order history.</p>
        <p>We never sell your personal information. Payment details are handled securely by Stripe and are never stored on our servers.</p>
        <p>You can request a copy of the data we hold about you, or ask us to delete your account, at any time by contacting our customer care team.</p>
        <p>We use cookies to keep you logged in and to understand how customers use our site so we can keep improving it.</p>
      </div>
    </div>
  );
}
